import store from '@/store';
/** Keys already used by a contract or document template; free text stays allowed in the editors. */
export function existingTemplateKeys() {
    const keys = [
        ...store.getters['contract/templates'].map((t) => t.data.key),
        ...store.getters['document/templates'].map((t) => t.data.key),
    ];
    return [...new Set(keys)].filter(key => !!key).sort();
}
